import { useEffect } from "react";

import { useViewData } from "../view-data";
import { useViewModel } from "../view-model";
import { useCreateOptionPmsItem } from "./use-create-option-pms-item";

import type * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
	optionPmsGetAvailableOptionListQueryData: Repository.Query.QueryData.OptionPmsGetAvailableOptionList.OptionPmsGetAvailableOptionListQueryData;
	initSearchDate: string;
	onQueryOptionPmsGetAvailableOptionList: (props: { hotelID: string; date: string }) => Promise<void>;
};

export const useInitialized = ({
	hotelID,
	optionPmsGetAvailableOptionListQueryData,
	initSearchDate,
	onQueryOptionPmsGetAvailableOptionList,
}: Props) => {
	/**
	 * ViewModel の生成
	 */
	const {
		//
		viewModel,
		// ゲスト名の変更
		onChangeGuestName,
		// 電話番号の変更
		onChangeGuestTel,
		// 日付の変更
		onChangeDate,
		// オプションの変更
		onChangeOption,
		// サブオプションの変更
		onChangeSubOption,
		// 数量の変更
		onChangeAmount,
		// コメントの変更
		onChangeComment,
	} = useViewModel({ hotelID, initSearchDate, optionPmsGetAvailableOptionListQueryData });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ viewModel, optionPmsGetAvailableOptionListQueryData });

	const {
		// オプションの作成
		onCreateOptionPms,
	} = useCreateOptionPmsItem({ hotelID, viewModel });

	useEffect(() => {
		/**
		 * オプションの再取得
		 */
		onQueryOptionPmsGetAvailableOptionList({ hotelID, date: viewModel.date });
	}, [hotelID, onQueryOptionPmsGetAvailableOptionList, viewModel.date]);

	return {
		//
		viewData,
		//
		viewModel,
		// ゲスト名の変更
		onChangeGuestName,
		// 電話番号の変更
		onChangeGuestTel,
		// 日付の変更
		onChangeDate,
		// オプションの変更
		onChangeOption,
		// サブオプションの変更
		onChangeSubOption,
		// 数量の変更
		onChangeAmount,
		// コメントの変更
		onChangeComment,
		//
		// オプション作成
		onCreateOptionPms,
	};
};
